export default {"src":"https://images-cdn-staging.curipod.com/d-01df1a2b/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};